export * from './agris-insert-insum-cotiz-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-insert-insum-cotiz-dialog/index.ts